import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Role-based default redirect component.
 * - Unauthenticated users → /login
 * - Attendee/Delegate → /my-weekend
 * - Organizer/Admin → /dashboard
 */
export function DefaultRedirect() {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'Attendee' || user.role === 'Delegate') {
    return <Navigate to="/my-weekend" replace />;
  }

  // Organizer and Admin roles
  return <Navigate to="/dashboard" replace />;
}
